// import React, { lazy, Suspense, useRef, useState } from "react";
// import styles from "./CompanyOtpVerify.module.css";

// const Button = lazy(() => import("../Dealers/Button"));

// const OTP_LENGTH = 6;

// const CompanyOtpVerify = ({
//   handleVerify,
//   createSettingsData,
//   mode,
//   onClose,
//   adminOtp,
//   setAdminOtp,
//   companyOtp,
//   setCompanyOtp,
//   loading,
// }) => {
//   const [error, setError] = useState("");

//   const adminRefs = useRef([]);
//   const settingsRefs = useRef([]);

//   // =========================
//   // OTP CHANGE
//   // =========================

//   const handleChange = (e, index, type) => {
//     const value = e.target.value;

//     if (!/^\d?$/.test(value)) return;

//     const otp = type === "admin" ? [...adminOtp] : [...companyOtp];

//     otp[index] = value;

//     if (type === "admin") {
//       setAdminOtp(otp);
//     } else {
//       setCompanyOtp(otp);
//     }

//     // Auto next focus

//     if (value && index < OTP_LENGTH - 1) {
//       const refs = type === "admin" ? adminRefs.current : settingsRefs.current;

//       refs[index + 1]?.focus();
//     }
//   };

//   // =========================
//   // BACKSPACE
//   // =========================

//   const handleKeyDown = (e, index, type) => {
//     const refs = type === "admin" ? adminRefs.current : settingsRefs.current;

//     if (e.key === "Backspace" && !e.target.value && index > 0) {
//       refs[index - 1]?.focus();
//     }
//   };

//   // =========================
//   // PASTE
//   // =========================

//   const handlePaste = (e, type) => {
//     e.preventDefault();

//     const pastedData = e.clipboardData
//       .getData("text")
//       .replace(/\D/g, "")
//       .slice(0, OTP_LENGTH);

//     if (!pastedData) return;

//     const otpArray = pastedData.split("");

//     while (otpArray.length < OTP_LENGTH) {
//       otpArray.push("");
//     }

//     if (type === "admin") {
//       setAdminOtp(otpArray);
//     } else {
//       setCompanyOtp(otpArray);
//     }
//   };

//   //   const handleVerify = async () => {
//   //     setError("");

//   //     // VALIDATION

//   //     if (adminOtp.includes("")) {
//   //       setError("Please enter admin OTP.");

//   //       return;
//   //     }

//   //     if (settingsOtp.includes("")) {
//   //       setError("Please enter profile OTP.");

//   //       return;
//   //     }

//   //     try {
//   //       setLoading(true);

//   //       // OTP

//   //       const adminEmailOtp = adminOtp.join("");

//   //       const emailOtp = settingsOtp.join("");

//   //       // API DATA

//   //       const payload = {
//   //         managerId,
//   //         deviceId,
//   //         ip: iPInfo?.ip,
//   //         browser: browserName,
//   //         os: operatinySystem,
//   //         city: iPInfo?.city,
//   //         state: iPInfo?.region,
//   //         country: iPInfo?.country_name,
//   //         adminEmailOtp,
//   //         emailOtp,
//   //       };

//   //       console.log("REQUEST:", payload);

//   //       // API CALL

//   //       const result = await fetchAcTokenData(
//   //         "admin/settings",
//   //         payload,
//   //         otpActoken,
//   //       );

//   //       console.log("RESPONSE:", result);

//   //       // SUCCESS

//   //       if (result?.status === "success") {
//   //         onVerify?.(result?.actoken);
//   //       } else {
//   //         setError(result?.msg || "Invalid OTP");
//   //       }
//   //     } catch (error) {
//   //       console.log(error);

//   //       setError("OTP verification failed");
//   //     } finally {
//   //       setLoading(false);
//   //     }
//   //   };

//   const renderOtpInputs = (otp, type, refs) => {
//     return (
//       <div className={styles.otpContainer}>
//         {otp.map((digit, index) => (
//           <input
//             key={index}
//             ref={(el) => (refs.current[index] = el)}
//             type="text"
//             inputMode="numeric"
//             maxLength={1}
//             value={digit}
//             className={styles.otpInput}
//             onChange={(e) => handleChange(e, index, type)}
//             onKeyDown={(e) => handleKeyDown(e, index, type)}
//             onPaste={(e) => handlePaste(e, type)}
//           />
//         ))}
//       </div>
//     );
//   };

//   return (
//     <div className={`${styles.modalCard} ${mode ? styles.dark : styles.light}`}>
//       {/* CLOSE BUTTON */}

//       <button className={styles.closeBtn} onClick={onClose}>
//         ×
//       </button>

//       {/* HEADER */}

//       <div className={styles.header}>
//         <h2 className={styles.title}>OTP Verification</h2>

//         <p className={styles.subTitle}>Verify both OTPs to continue</p>
//       </div>

//       {/* ADMIN OTP */}

//       <div className={styles.section}>
//         <label className={styles.label}>Admin Email OTP</label>

//         {renderOtpInputs(adminOtp, "admin", adminRefs)}
//       </div>

//       {/* PROFILE OTP */}

//       <div className={styles.section}>
//         <label className={styles.label}>Profile Email OTP</label>

//         {renderOtpInputs(companyOtp, "settings", settingsRefs)}
//       </div>

//       {/* ERROR */}

//       {error && <div className={styles.errorBox}>{error}</div>}

//       {/* BUTTON */}

//       <div className={styles.footer}>
//         <Suspense fallback={<button>Loading...</button>}>
//           <Button
//             type="button"
//             // buttonClick={handleVerify}
//             buttonClick={createSettingsData}
//             disabled={loading}
//             buttonText={loading ? "Verifying..." : "Verify OTP"}
//             buttonBgColor="#4164E3"
//             buttonTextColor="#ffffff"
//             buttonBorder="none"
//             loading={loading}
//           />
//         </Suspense>
//       </div>
//     </div>
//   );
// };

// export default CompanyOtpVerify;

import React, { lazy, Suspense, useRef, useState } from "react";
import styles from "./CompanyOtpVerify.module.css";

const Button = lazy(() => import("../Dealers/Button"));

const OTP_LENGTH = 6;

const CompanyOtpVerify = ({
  createSettingsData, // called on Verify click (addUpSettings WITH otps)
  mode,
  onClose,
  adminOtp,
  setAdminOtp,
  companyOtp,
  setCompanyOtp,
  loading,
}) => {
  const [error, setError] = useState("");

  const adminRefs = useRef([]);
  const settingsRefs = useRef([]);

  // ─── OTP digit change ──────────────────────────────────────────────────────
  const handleChange = (e, index, type) => {
    const value = e.target.value;
    if (!/^\d?$/.test(value)) return;

    const otp = type === "admin" ? [...adminOtp] : [...companyOtp];
    otp[index] = value;

    if (type === "admin") {
      setAdminOtp(otp);
    } else {
      setCompanyOtp(otp);
    }

    // Auto-advance focus
    if (value && index < OTP_LENGTH - 1) {
      const refs = type === "admin" ? adminRefs.current : settingsRefs.current;
      refs[index + 1]?.focus();
    }
  };

  // ─── Backspace ─────────────────────────────────────────────────────────────
  const handleKeyDown = (e, index, type) => {
    const refs = type === "admin" ? adminRefs.current : settingsRefs.current;
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      refs[index - 1]?.focus();
    }
  };

  // ─── Paste ─────────────────────────────────────────────────────────────────
  const handlePaste = (e, type) => {
    e.preventDefault();
    const pastedData = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, OTP_LENGTH);
    if (!pastedData) return;

    const otpArray = pastedData.split("");
    while (otpArray.length < OTP_LENGTH) otpArray.push("");

    if (type === "admin") {
      setAdminOtp(otpArray);
    } else {
      setCompanyOtp(otpArray);
    }
  };

  // ─── Local validation before calling parent ────────────────────────────────
  const handleVerifyClick = () => {
    setError("");

    if (adminOtp.some((d) => d === "")) {
      setError("Please enter the complete Admin OTP.");
      return;
    }
    if (companyOtp.some((d) => d === "")) {
      setError("Please enter the complete Profile OTP.");
      return;
    }

    createSettingsData();
  };

  // ─── Render OTP boxes ──────────────────────────────────────────────────────
  const renderOtpInputs = (otp, type, refs) => (
    <div className={styles.otpContainer}>
      {otp.map((digit, index) => (
        <input
          key={index}
          ref={(el) => (refs.current[index] = el)}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={digit}
          className={styles.otpInput}
          onChange={(e) => handleChange(e, index, type)}
          onKeyDown={(e) => handleKeyDown(e, index, type)}
          onPaste={(e) => handlePaste(e, type)}
        />
      ))}
    </div>
  );

  return (
    <div className={`${styles.modalCard} ${mode ? styles.dark : styles.light}`}>
      {/* Close button */}
      <button className={styles.closeBtn} onClick={onClose} type="button">
        ×
      </button>

      {/* Header */}
      <div className={styles.header}>
        <h2 className={styles.title}>OTP Verification</h2>
        <p className={styles.subTitle}>
          OTPs have been sent to both Admin and Company email addresses.
        </p>
      </div>

      {/* Admin OTP */}
      <div className={styles.section}>
        <label className={styles.label}>Admin Email OTP</label>
        {renderOtpInputs(adminOtp, "admin", adminRefs)}
      </div>

      {/* Company / Profile OTP */}
      <div className={styles.section}>
        <label className={styles.label}>Profile Email OTP</label>
        {renderOtpInputs(companyOtp, "settings", settingsRefs)}
      </div>

      {/* Error */}
      {error && <div className={styles.errorBox}>{error}</div>}

      {/* Verify Button */}
      <div className={styles.footer}>
        <Suspense fallback={<button>Loading...</button>}>
          <Button
            type="button"
            buttonClick={handleVerifyClick}
            disabled={loading}
            buttonText={loading ? "Verifying..." : "Verify & Save"}
            buttonBgColor="#4164E3"
            buttonTextColor="#ffffff"
            buttonBorder="none"
            loading={loading}
          />
        </Suspense>
      </div>
    </div>
  );
};

export default CompanyOtpVerify;
